// Pure parsers for Search-page voice commands (filters, save, pick).
import { findDiets } from "@/lib/diets";

const NUM_WORDS = {
  five: 5, ten: 10, fifteen: 15, twenty: 20, "twenty five": 25, thirty: 30, "thirty five": 35,
  forty: 40, "forty five": 45, fifty: 50, sixty: 60, ninety: 90,
};
const ORD = { one: 1, first: 1, two: 2, second: 2, three: 3, third: 3, four: 4, fourth: 4, five: 5, fifth: 5 };

export const FILTER_RE = /\b(?:only|just)\s+(?:mine|my\s+own|my\s+recipes|shared|public|historical|the\s+historical)|\bshared\s+with\s+me\b|\bmy\s+own\s+(?:ones|recipes)\b|\bquick(?:\s+ones)?\b|\bfast\s+ones\b|\b(?:under|less\s+than|within|no\s+more\s+than)\s+(?:an?\s+|half\s+an\s+)?\w+(?:\s+\w+)?\s*(?:minutes?|mins?|hours?|hrs?|hour)\b|\beasy(?:\s+ones)?\b|\bsimple\s+ones\b|\bshow\s+everything\b|\b(?:clear|reset|remove)\s+(?:the\s+|all\s+)?filters?\b|\b(?:only|just|make\s+(?:them|it|these|those)|which\s+are|that\s+are)\s+(?:the\s+)?(?:vegan|vegetarian|veggie|pesc[ae]tarian|plant[\s-]+based|meat[\s-]+free|(?:gluten|dairy|lactose|egg|nut|soya?)[\s-]+free|coeliac|celiac|low[\s-]+(?:fodmap|histamine|gi)|diabetic|(?:kidney|renal)[\s-]+friendly)\b|\b(?:vegan|vegetarian|veggie|(?:gluten|dairy|egg|nut|soya?)[\s-]+free|low[\s-]+(?:fodmap|histamine)|diabetic)\s+ones\b/;

export function parseFilters(txt) {
  const t = txt.toLowerCase();
  if (/\bshow\s+everything\b|\b(?:clear|reset|remove)\s+(?:the\s+|all\s+)?filters?\b|\bshow\s+all\s+results\b/.test(t)) return { clear: true };
  const out = {};
  if (/\b(?:only|just)\s+(?:mine|my\s+own|my\s+recipes)\b|\bmy\s+own\s+(?:ones|recipes)\b/.test(t)) out.src = "mine";
  else if (/\b(?:only|just)\s+shared\b|\bshared\s+with\s+me\b/.test(t)) out.src = "shared";
  else if (/\b(?:only|just)\s+public\b/.test(t)) out.src = "public";
  else if (/\b(?:only|just)\s+(?:the\s+)?historical\b/.test(t)) out.src = "historical";
  if (/\bquick(?:\s+ones)?\b|\bfast\s+ones\b/.test(t)) out.max = 30;
  if (/\bhalf\s+an\s+hour\b/.test(t)) out.max = 30;
  else if (/\b(?:under|less\s+than|within|no\s+more\s+than)\s+an?\s+hour\b/.test(t)) out.max = 60;
  else {
    const m = t.match(/\b(?:under|less\s+than|within|no\s+more\s+than)\s+(\d+|[a-z]+(?:\s+[a-z]+)?)\s*(minutes?|mins?|hours?|hrs?)\b/);
    if (m) {
      const n = /^\d+$/.test(m[1]) ? parseInt(m[1], 10) : NUM_WORDS[m[1].trim()];
      if (n) out.max = /^h/.test(m[2]) ? n * 60 : n;
    }
  }
  if (/\beasy(?:\s+ones)?\b|\bsimple\s+ones\b/.test(t)) out.easy = true;
  const { diets } = findDiets(t);
  if (diets.length) out.diets = diets;
  return Object.keys(out).length ? out : null;
}

export const SAVE_RE = /^(?:please\s+)?save\s+(?:all\s+)?(?:of\s+)?(?:these|them|this|those|the\s+results|these\s+results|this\s+list)\s+(?:as|to|into)\s+(?:a\s+)?(?:new\s+)?(?:cookbook\s+)?(?:called\s+|named\s+)?(.+)$/;

export function parseSaveTitle(txt) {
  const m = txt.toLowerCase().trim().match(SAVE_RE);
  if (!m) return null;
  const name = m[1].replace(/\s+(?:cookbook|please)$/, "").trim();
  return name.replace(/\b\w/g, (c) => c.toUpperCase());
}

export const PICK_RE = /^(?:open\s+|show\s+|go\s+to\s+)?(?:number\s+|the\s+)?(\d{1,2}|one|two|three|four|five|first|second|third|fourth|fifth)(?:\s+one)?$/;

export function parsePick(txt) {
  const m = txt.toLowerCase().trim().match(PICK_RE);
  if (!m) return -1;
  const n = /^\d+$/.test(m[1]) ? parseInt(m[1], 10) : ORD[m[1]];
  return n ? n - 1 : -1;
}

export function applyFilters(items, f) {
  return items.filter((it) => {
    if (f.src && it.source !== f.src) return false;
    if (f.max && !(it.total_minutes && it.total_minutes <= f.max)) return false;
    if (f.easy && it.difficulty !== "Easy") return false;
    if (f.diets?.length && !f.diets.every((d) => (it.diet_badges || []).includes(d))) return false;
    return true;
  });
}

const NUMW = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10,
  first: 1, second: 2, third: 3, fourth: 4, fifth: 5, sixth: 6, seventh: 7, eighth: 8, ninth: 9, tenth: 10 };

const _N = "(?:\\d{1,2}|one|two|three|four|five|six|seven|eight|nine|ten|first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth)";
export const ADD_RE = new RegExp(
  `^(?:please\\s+)?(?:add|save|put|copy)\\s+((?:all(?:\\s+of)?(?:\\s+these|\\s+them)?|these|them|those|everything)|(?:(?:the\\s+)?numbers?\\s+|the\\s+)?${_N}(?:(?:\\s*,\\s*|\\s+and\\s+|\\s+&\\s+|\\s+)(?:numbers?\\s+)?${_N})*(?:\\s+ones?)?)\\s+(?:to|into|in)\\s+(?!(?:my\\s+|the\\s+)?(?:shopping\\s+)?list\\b)(?:my\\s+|the\\s+|our\\s+)?(.+?)(?:\\s+cook\\s?book)?$`,
);

// "add number 3 to my sunday dinners cookbook" → { indices: [2], name: "sunday dinners" }
// "add all of these to sunday dinners" → { all: true, name }
export function parseAdd(txt) {
  const m = txt.toLowerCase().trim().replace(/[.?!]+$/, "").match(ADD_RE);
  if (!m) return null;
  const what = m[1].replace(/\b(?:numbers?|recipes?|the|ones?)\b/g, " ").trim();
  const name = m[2].trim();
  if (!name || /^(?:shopping\s+list|list|basket|cart|meal\s+plan(?:ner)?)$/.test(name)) return null;
  if (/^(?:all(?:\s+of)?(?:\s+these|\s+them)?|these|them|everything|those)$/.test(what)) return { all: true, name };
  const parts = what.split(/\s*(?:,|\band\b|&|\s)\s*/).filter(Boolean);
  const idx = [];
  for (const p of parts) {
    const n = /^\d+$/.test(p) ? parseInt(p, 10) : NUMW[p];
    if (!n) return null;
    idx.push(n - 1);
  }
  return idx.length ? { indices: [...new Set(idx)], name } : null;
}
